class ArticleInlineAdCarousel extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initFrame = window.requestAnimationFrame(() => this.initialize());
  }

  initialize() {
    if (this.initialized || !this.isConnected) return;

    this.slides = Array.from(this.querySelectorAll('[data-article-inline-ad-slide]'));
    this.prevButton = this.querySelector('[data-article-inline-ad-prev]');
    this.nextButton = this.querySelector('[data-article-inline-ad-next]');
    this.currentIndicator = this.querySelector('[data-article-inline-ad-current]');
    this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
    this.currentIndex = this.currentIndex >= 0 ? this.currentIndex : 0;
    this.autoplayInterval = Number(this.dataset.autoplayInterval) || 0;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.paused = false;

    if (this.slides.length < 2) return;

    this.initialized = true;
    this.abortController = new AbortController();
    const options = { signal: this.abortController.signal };

    this.prevButton?.addEventListener('click', () => this.showPrevious(true), options);
    this.nextButton?.addEventListener('click', () => this.showNext(true), options);
    this.addEventListener('mouseenter', () => this.pause(), options);
    this.addEventListener('mouseleave', () => this.resume(), options);
    this.addEventListener('focusin', () => this.pause(), options);
    this.addEventListener(
      'focusout',
      (event) => {
        if (!this.contains(event.relatedTarget)) this.resume();
      },
      options
    );
    this.addEventListener(
      'keydown',
      (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.showPrevious(true);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.showNext(true);
        }
      },
      options
    );

    this.setAttribute('data-carousel-ready', 'true');
    this.showSlide(this.currentIndex);
    this.startAutoplay();
  }

  disconnectedCallback() {
    if (this.initFrame) {
      window.cancelAnimationFrame(this.initFrame);
      this.initFrame = undefined;
    }

    this.stopAutoplay();
    this.abortController?.abort();
  }

  showPrevious(manual = false) {
    this.showSlide(this.currentIndex - 1, manual);
  }

  showNext(manual = false) {
    this.showSlide(this.currentIndex + 1, manual);
  }

  showSlide(index, manual = false) {
    const nextIndex = (index + this.slides.length) % this.slides.length;

    this.slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === nextIndex;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    this.currentIndex = nextIndex;

    if (this.currentIndicator) {
      this.currentIndicator.textContent = String(nextIndex + 1);
    }

    if (manual) {
      this.restartAutoplay();
    }
  }

  startAutoplay() {
    if (this.reducedMotion || this.autoplayInterval <= 0 || this.paused) return;

    this.stopAutoplay();
    this.autoplayTimer = window.setInterval(() => {
      this.showNext();
    }, this.autoplayInterval);
  }

  stopAutoplay() {
    if (!this.autoplayTimer) return;

    window.clearInterval(this.autoplayTimer);
    this.autoplayTimer = undefined;
  }

  restartAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }

  pause() {
    this.paused = true;
    this.stopAutoplay();
  }

  resume() {
    this.paused = false;
    this.startAutoplay();
  }
}

if (!customElements.get('article-inline-ad-carousel')) {
  customElements.define('article-inline-ad-carousel', ArticleInlineAdCarousel);
}
